import React from 'react'
import AuthLayoutHeader from '../components/auth/AuthLayoutHeader'
import ResetPasswordForm from '../components/auth/ResetPasswordForm'

const ResetPassword: React.FC = () => {
  return (
    <>
      <AuthLayoutHeader title="Reset Password" />
      <span className="mt-6 block bg-white text-gray-500">
        Please enter the email address associated with your account. We’ll send you an email with instructions to reset
        your password.
      </span>

      <div className="mt-6">
        <ResetPasswordForm />
      </div>
    </>
  )
}

export default ResetPassword
